import "../RewardList/RewardList.scss";

import moment from "moment";
import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import RewardListCanvas from "../RewardListCanvas";

const RewardList = ({ rewards, currencyView }) => {
  const [showCanvas, setShowCanvas] = useState(false);

  return rewards?.length ? (
    <>
      <div className="rewardlist-container">
        <p>Redeem on your next purchase</p>
        {rewards?.slice(0, 2)?.map((reward) => (
          <RewardItem
            reward={reward}
            key={reward?._id}
            currencyView={currencyView}
          />
        ))}
        {rewards?.length > 2 && (
          <button onClick={() => setShowCanvas(!showCanvas)}>View more</button>
        )}
      </div>
      <RewardListCanvas
        rewards={rewards}
        isOpen={showCanvas}
        currencyView={currencyView}
        toggleCanvas={() => setShowCanvas(!showCanvas)}
      />
    </>
  ) : (
    <></>
  );
};

export const RewardItem = ({ reward, isTerms, currencyView }) => {
  return (
    <div className="main-container">
      <div className="rewarditem">
        <div className="reward-content">
          <div className="upper-content">
            <hr />
            <span>
              {reward?.reward_type === "campaign"
                ? reward?.name
                : getRewardType(reward, currencyView)}
            </span>
            {reward?.type === "amount_off" ||
            reward?.redeem_type === "amount_off" ||
            reward?.type === "discount_off" ||
            reward?.redeem_type === "discount_off" ? (
              <img src="/assets/icons/amount_off.svg" alt="amount-icon" />
            ) : reward?.type === "percentage_off" ||
              reward?.redeem_type === "percentage_off" ? (
              <img
                alt="percentage-icon"
                src="/assets/icons/percentage_off.svg"
              />
            ) : (
              <img src="/assets/icons/gift-4.svg" alt="gift-icon" />
            )}
            <div className="circle1" />
            <div className="circle2" />
          </div>
          <div className="dotted-line"></div>
          <div className="lower-content">
            {reward?.applicable_stores?.length ? (
              <h4>Redeem at {reward?.applicable_stores?.length || 1} stores</h4>
            ) : (
              <></>
            )}
            {reward?.expires_at && (
              <span>
                Expires on {moment(reward?.expires_at)?.format("Do MMM")}
              </span>
            )}
          </div>
          {isTerms ? (
            <Accordion defaultActiveKey={0} className="terms-conditions">
              <Accordion.Item>
                <Accordion.Header>
                  <span>Terms and conditions</span>
                </Accordion.Header>
                <Accordion.Body>
                  <div>
                    <ul>
                      {typeof reward?.terms === "string"
                        ? reward?.terms
                            ?.split("\n")
                            ?.map((term, i) => <li key={i}>{term}</li>)
                        : reward?.terms?.map((term, i) => (
                            <li key={i}>{term?.text}</li>
                          ))}
                    </ul>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardList;

const getRewardType = (doc, currencyView) => {
  const rewardType = doc?.type || doc?.redeem_type;
  if (rewardType === "free_item_service")
    return `Get free ${doc?.items?.map((item) => item.name)?.join(", ")}`;
  if (rewardType === "amount_off" || rewardType === "discount_off")
    return `Get ${currencyView}${
      doc?.amount_off || doc?.discount_off
    } discount`;
  if (rewardType === "percentage_off")
    return `Get ${doc?.percentage_off}% discount`;

  return "";
};
